var map = {
	"./半夏.jpg": 8427,
	"./厚朴.jpg": 671,
	"./泽泻.jpg": 1038,
	"./滑石.jpg": 8134,
	"./猪苓.jpg": 9045,
	"./白术.jpg": 5438,
	"./赤茯苓.jpg": 2153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5625;